/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Go as Go,
  rec_Hi as Hi,
  rec_JSXRuntime as JSXRuntime,
  rec_MarcaCarga as MarcaCarga,
  rec_React as React,
  rec_Xo as Xo,
  rec_Zo as Zo,
  rec__C as _C,
  rec_api as api,
  rec_br as br,
  rec_ea as ea,
  rec_es as es,
  rec_gC as gC,
  rec_hC as hC,
  rec_ii as ii,
  rec_kr as kr,
  rec_pi as pi,
  rec_rs as rs,
  rec_sS as sS,
  rec_st as st,
  rec_ta as ta,
  rec_uS as uS,
  rec_xr as xr,
} from "../../runtime/index.jsx";
export function Notificaciones() {
  let e = st(),
    t = Go(),
    [n, r] = (0, React.useState)([]),
    [i, a] = (0, React.useState)(!0),
    [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(!1),
    u = (0, React.useCallback)(async () => {
      (a(!0), s(``));
      try {
        r(await api(`/notificaciones?limite=80${c ? `&noLeidas=true` : ``}`));
      } catch (e) {
        s(e.message);
      } finally {
        a(!1);
      }
    }, [c]);
  (0, React.useEffect)(() => {
    u();
  }, [u]);
  let [f, p] = (0, React.useState)(Xo);
  function m(e) {
    (Zo(e), p(e), e && (es(`exito`), rs(`exito`)));
  }
  let [h, g] = (0, React.useState)(!1);
  async function _() {
    if (!h) {
      g(!0);
      try {
        let e = await api(`/notificaciones/probar-whatsapp`, {
          method: `POST`,
        });
        e?.enviado
          ? t.ok(`Te lo mandamos al WhatsApp`)
          : t.info(e?.motivo ?? `No hay nada para avisarte hoy`);
      } catch (e) {
        t.error(e.message);
      } finally {
        g(!1);
      }
    }
  }
  let [v, y] = (0, React.useState)(`inactivo`),
    [b, x] = (0, React.useState)(!1);
  (0, React.useEffect)(() => {
    hC().then(y);
  }, []);
  async function S() {
    (x(!0), s(``));
    try {
      v === `activo` ? (await _C(), y(`inactivo`)) : (await gC(), y(`activo`));
    } catch (e) {
      s(e.message);
    } finally {
      x(!1);
    }
  }
  async function C(t) {
    (t.leida ||
      (await api(`/notificaciones/${t.id}/leida`, {
        method: `POST`,
      }).catch(() => {})),
      t.enlace ? e(t.enlace) : u());
  }
  async function w() {
    (await api(`/notificaciones/leidas`, {
      method: `POST`,
    }).catch(() => {}),
      window.dispatchEvent(new Event(`sesion-actualizada`)),
      u());
  }
  return (
    <EstructuraPrincipal
      title={`Notificaciones`}
      children={
        <div
          className={`flex flex-col gap-4`}
          children={[
            v !== `no-soportado` && (
              <div
                className={`animar-entrada flex flex-wrap items-center gap-3 rounded-2xl border border-(--border) bg-(--bg) p-3`}
                children={[
                  <Hi className={`h-5 w-5 shrink-0 text-(--text)`} />,
                  <div
                    className={`min-w-0 flex-1`}
                    children={[
                      <p
                        className={`text-sm font-medium text-(--text-h)`}
                        children={`Notificaciones en este dispositivo`}
                      />,
                      <p
                        className={`text-xs text-(--text)`}
                        children={
                          v === `requiere-instalar`
                            ? `En iPhone los avisos llegan sólo con la app instalada: en Safari toca Compartir → «Agregar a inicio», ábrela desde el ícono y actívalos acá.`
                            : v === `bloqueado`
                            ? /iphone|ipad|ipod/i.test(navigator.userAgent)
                              ? `Están bloqueadas — habilítalas en Ajustes → Notificaciones → esta app.`
                              : /android/i.test(navigator.userAgent)
                                ? `Están bloqueadas — mantén presionado el ícono de la app → Información → Notificaciones.`
                                : `Están bloqueadas — habilítalas en el candado de la barra de dirección.`
                            : v === `activo`
                              ? `Activadas: te llegan aunque el navegador esté cerrado.`
                              : `Recibí un aviso al celular/PC cuando algo te necesita, aunque no tengas la app abierta.`
                        }
                      />,
                    ]}
                  />,
                  v !== `bloqueado` && v !== `requiere-instalar` && (
                    <button
                      type={`button`}
                      onClick={S}
                      disabled={b}
                      className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition disabled:opacity-50 ${v === `activo` ? `border border-(--border) text-(--text-h) hover:bg-(--accent-bg)` : `bg-(--accent) text-(--accent-fg) hover:opacity-90`}`}
                      children={[
                        b
                          ? (0, JSXRuntime.jsx)(ii, {
                              className: `h-4 w-4 animate-spin`,
                            })
                          : (0, JSXRuntime.jsx)(br, {
                              className: `h-4 w-4`,
                            }),
                        v === `activo` ? `Desactivar` : `Activar`,
                      ]}
                    />
                  ),
                ]}
              />
            ),
            <div
              className={`animar-entrada flex flex-wrap items-center gap-3 rounded-2xl border border-(--border) bg-(--bg) p-3`}
              children={[
                f
                  ? (0, JSXRuntime.jsx)(ea, {
                      className: `h-5 w-5 shrink-0 text-(--text)`,
                    })
                  : (0, JSXRuntime.jsx)(ta, {
                      className: `h-5 w-5 shrink-0 text-(--text)`,
                    }),
                <div
                  className={`min-w-0 flex-1`}
                  children={[
                    <p
                      className={`text-sm font-medium text-(--text-h)`}
                      children={`Sonido y vibración`}
                    />,
                    <p
                      className={`text-xs text-(--text)`}
                      children={`Un sonido corto cuando algo se aprueba o se termina, y otro distinto cuando algo falla. En el celular, además, una vibración breve al tocar los botones.`}
                    />,
                  ]}
                />,
                <MarcaCarga
                  checked={f}
                  onChange={m}
                  children={f ? `Activado` : `Apagado`}
                />,
              ]}
            />,
            <div
              className={`animar-entrada flex flex-wrap items-center gap-3 rounded-2xl border border-(--border) bg-(--bg) p-3`}
              children={[
                (0, JSXRuntime.jsx)(pi, {
                  className: `h-5 w-5 shrink-0 text-(--text)`,
                }),
                <div
                  className={`min-w-0 flex-1`}
                  children={[
                    <p
                      className={`text-sm font-medium text-(--text-h)`}
                      children={`Tu resumen por WhatsApp`}
                    />,
                    <p
                      className={`text-xs text-(--text)`}
                      children={`Los domingos, lo que vence la semana que viene. De lunes a sábado, lo del día. Necesitás tener tu celular cargado en tu cuenta.`}
                    />,
                  ]}
                />,
                <button
                  type={`button`}
                  onClick={_}
                  disabled={h}
                  className={`shrink-0 rounded-full border border-(--border) px-3 py-1.5 text-xs font-medium text-(--text-h) hover:bg-(--accent-bg) disabled:opacity-60`}
                  children={h ? `Enviando…` : `Mandármelo ahora`}
                />,
              ]}
            />,
            <div
              className={`flex items-center justify-between`}
              children={[
                <MarcaCarga
                  checked={c}
                  onChange={l}
                  children={`Solo no leidas`}
                />,
                <button
                  type={`button`}
                  onClick={w}
                  className={`flex items-center gap-1 rounded-full border border-(--border) px-3 py-1.5 text-xs font-medium text-(--text-h) hover:bg-(--accent-bg)`}
                  children={[
                    (0, JSXRuntime.jsx)(kr, {
                      className: `h-3.5 w-3.5`,
                    }),
                    ` Marcar todo como leido`,
                  ]}
                />,
              ]}
            />,
            <EstadoError mensaje={o} onReintentar={u} />,
            i ? (
              <div
                className={`flex items-center gap-2 text-sm text-(--text)`}
                children={[
                  (0, JSXRuntime.jsx)(ii, {
                    className: `h-4 w-4 animate-spin`,
                  }),
                  ` Cargando…`,
                ]}
              />
            ) : n.length === 0 ? (
              <div
                className={`animar-entrada rounded-2xl border border-dashed border-(--border) p-10 text-center`}
                children={[
                  (0, JSXRuntime.jsx)(xr, {
                    className: `mx-auto h-8 w-8 text-(--text)`,
                  }),
                  <p
                    className={`mt-2 text-sm text-(--text)`}
                    children={`Nada por aca.`}
                  />,
                ]}
              />
            ) : (
              <ul
                className={`flex flex-col gap-2`}
                children={n.map((e) => (
                  <li
                    key={e.id}
                    children={
                      <button
                        type={`button`}
                        onClick={() => C(e)}
                        className={`flex w-full flex-col items-start gap-1 rounded-2xl border p-3 text-left transition hover:shadow-(--shadow) ${e.leida ? `border-(--border) bg-(--bg)` : `border-(--accent-border) bg-(--accent-bg)`}`}
                        children={[
                          <span
                            className={`flex w-full items-center gap-2`}
                            children={[
                              !e.leida && (
                                <span
                                  className={`h-1.5 w-1.5 shrink-0 rounded-full bg-(--accent)`}
                                />
                              ),
                              <span
                                className={`min-w-0 flex-1 font-medium text-(--text-h)`}
                                children={e.titulo}
                              />,
                              <span
                                className={`shrink-0 text-xs text-(--text)`}
                                children={uS(e.creadoEn)}
                              />,
                            ]}
                          />,
                          e.cuerpo && (
                            <span
                              className={`text-sm text-(--text)`}
                              children={e.cuerpo}
                            />
                          ),
                          <span
                            className={`text-[10px] uppercase tracking-wide text-(--text)/70`}
                            children={sS(e.tipo)}
                          />,
                        ]}
                      />
                    }
                  />
                ))}
              />
            ),
          ]}
        />
      }
    />
  );
}
